import React, { useEffect, useRef } from 'react';

import { easeElastic } from 'd3-ease';
import { select } from 'd3-selection';
import { transition } from 'd3-transition'

import COLORS from '../../../../constants/colors.constants';

const Point = ({
  id,
  cx,
  cy,
  color,
  strokeWidth,
  radius,
  animateHover = false,
}) => {
  const pointRef = useRef(null);

  useEffect(() => {
    if (pointRef?.current && animateHover) {
      const t = transition()
        .duration(750)
        .ease(easeElastic)

      select(pointRef.current).transition(t).attr('r', radius);
    }
  }, [animateHover, radius])

  const radiusProps = animateHover ? {} : { r: radius };
  return (
    <circle
      id={id}
      ref={pointRef}
      r={radius}
      cx={cx}
      cy={cy}
      fill={color}
      strokeWidth={strokeWidth}
      {...radiusProps}
    />
  )
}

export const Points = ({
  id,
  xScale,
  yScale,
  selectedPoint = null,
  radius = 4,
  strokeWidth = 2,
  points = [],
  color = COLORS.brand,
  animateHover = false,
}) => (
  <g className="dots-group">
    {
      points?.map((point) => {
        if (!point.y) {
          return null;
        }
        const isSelected = selectedPoint && selectedPoint.x === point.x && selectedPoint.y === point.y;
        return (
          <Point
            id={`${id}-${point.x.getTime()}-${point.y}`}
            key={`point-${id}-${point.x.getTime()}-${point.y}`}
            cx={xScale(point.x)}
            cy={yScale(point.y)}
            radius={isSelected ? radius * 2 : radius}
            strokeWidth={strokeWidth}
            color={point?.color ? point.color : color}
            animateHover={animateHover}
          />
        )
      })
    }
  </g>
)

export default Points;
